import React, { useState } from "react";
import "./qualification.css";

function Qualification() {
  const [toggleState, setToggleState] = useState(1);

  const toggleTab = (index) => {
    setToggleState(index);
  };

  return (
    <section className="qualification section">
      <h2 className="section__title">Qualification</h2>
      <span className="section__subtitle">My personal Journey</span>
      <div className="qualification__container container">
        <div className="qualification__tabs">
          <div
            className={
              toggleState === 1
                ? "qualification__button qualification__active button--flex"
                : "qualification__button button--flex "
            }
            onClick={() => toggleTab(1)}
          >
            <i className="uil uil-graduation-cap qualification-icon"></i>
            Education
          </div>

          <div
            className={
              toggleState === 2
                ? "qualification__button qualification__active button--flex"
                : "qualification__button button--flex "
            }
            onClick={() => toggleTab(2)}
          >
            <i className="uil uil-briefcase-alt qualification-icon"></i>
            Experience
          </div>
        </div>

        <div className="qualification__sections">
          <div
            className={
              toggleState === 1
                ? "qualification__content qualification__content-active"
                : "qualification__content"
            }
          >
            <div className="qualification__data">
              <div>
                <h3 className="qualification__title">
                  Bachelors in Software Engineeing
                </h3>
                <span className="qualification__subtitle">MCS-NUST</span>
                <div className="qualification__calendar">
                  <i className="uil uil-calendar-alt"></i>Nov 2021-Present
                </div>
              </div>
              <div>
                <span className="qualification__rounder"></span>
                <span className="qualification__line"></span>
              </div>
            </div>
            <div className="qualification__data">
              <div></div>
              <div>
                <span className="qualification__rounder"></span>
                <span className="qualification__line"></span>
              </div>
              <div>
                <h3 className="qualification__title">
                  META frontend Certification
                </h3>
                <span className="qualification__subtitle">Coursera</span>
                <div className="qualification__calendar">
                  <i className="uil uil-calendar-alt"></i>April 2023 - August
                  2023
                </div>
              </div>
            </div>

            <div className="qualification__data">
              <div>
                <h3 className="qualification__title">FSc</h3>
                <span className="qualification__subtitle">FFCB</span>
                <div className="qualification__calendar">
                  <i className="uil uil-calendar-alt"></i>2018-2020
                </div>
              </div>
              <div>
                <span className="qualification__rounder"></span>
                <span className="qualification__line"></span>
              </div>
            </div>
            <div className="qualification__data">
              <div></div>
              <div>
                <span span className="qualification__rounder"></span>
                <span className="qualification__line"></span>
              </div>
              <div>
                <h3 className="qualification__title">Matric</h3>
                <span className="qualification__subtitle">FFMS</span>
                <div className="qualification__calendar">
                  <i className="uil uil-calendar-alt"></i>2016-2018
                </div>
              </div>
            </div>
          </div>
          <div
            className={
              toggleState === 2
                ? "qualification__content qualification__content-active"
                : "qualification__content"
            }
          >
            <div className="qualification__data">
              <div>
                <h3 className="qualification__title">MERN dev intern</h3>
                <span className="qualification__subtitle">MCS-NUST</span>
                <div className="qualification__calendar">
                  <i className="uil uil-calendar-alt"></i>July 2023-Sep 2023
                </div>
              </div>
              <div>
                <span className="qualification__rounder"></span>
                <span className="qualification__line"></span>
              </div>
            </div>

            <div className="qualification__data">
              <div></div>
              <div>
                <span className="qualification__rounder"></span>
                <span className="qualification__line"></span>
              </div>
              <div>
                <h3 className="qualification__title">Freelancer</h3>
                <span className="qualification__subtitle">Fiverr</span>
                <div className="qualification__calendar">
                  <i className="uil uil-calendar-alt"></i>2021-Present
                </div>
              </div>
            </div>

            <div className="qualification__data">
              <div>
                <h3 className="qualification__title">Intern </h3>
                <span className="qualification__subtitle">Arcana Info Pvt Ltd</span>
                <div className="qualification__calendar">
                  <i className="uil uil-calendar-alt"></i>July 2021
                </div>
              </div>
              <div>
                <span className="qualification__rounder"></span>
                <span className="qualification__line"></span>
              </div>
            </div>

            {/* <div className="qualification__data">
              <div></div>
              <div>
                <span className="qualification__rounder"></span>
                <span className="qualification__line"></span>
              </div>
              <div>
                <h3 className="qualification__title">Art</h3>
                <span className="qualification__subtitle">NUST</span>
                <div className="qualification__calendar">
                  <i className="uil uil-calendar-alt"></i>2021-Present
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </section>
  );
}

export default Qualification;
